var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('scanBasic',_vm._b({ref:"scanBasic"},'scanBasic',_vm.basicProps,false)),_vm._v(" "),(_vm.isShow)?_c('div',[_c('popupSelection',_vm._b({ref:"popupSelection",on:{"on-cancel":_vm.onCancel,"on-ok-continue":_vm.onOkAndContinue}},'popupSelection',_vm.popupProps,false))],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }